/*
  Collection guide (Oct 18 2026, v4).
  Place pills (tablist: roving tabindex, Left/Right/Home/End) and a Pair / One
  radio group choose which view of sections/collection-guide.liquid is shown.
  The switch is hidden for a place with a single mode.
  Each view's carousel shows up to 12 products from the ?view=guide-data feed
  (templates/collection.guide-data.liquid): best-seller order, available,
  height within [min, max], one product per design family within the carousel.
  A carousel with fewer than 3 products is hidden. The first 5 images of the
  visible carousel load eagerly; the rest are lazy.
  Fetch starts on DOMContentLoaded, or earlier if the guide comes within 600px
  of the viewport. Skeleton cards in the Liquid hold the space until then.
  Cards are the grid's own product-card markup, rendered server-side in the feed
  (p.card), so wishlist hearts, swatches, labels and prices match the grid.
  No client cache (Oct 19 2026): the feed is fetched on each page view, and
  cards always render from the fetched data. Only a failed fetch hides the
  carousels; lazy-image and wishlist set-up run afterwards, each guarded, so a
  third-party error can never remove the cards.
  Door height (Oct 19 2026): places with custom.guide_sizing heights get a
  Door height radio group; each place / height / mode has its own view. When
  fewer than 3 products fit a view's range, it shows the products closest to
  the range, largest first, under "Our largest outdoor wall lights".
  GA4 (Oct 20 2026): view_item_list when a filled carousel is shown, and
  select_item on a product link click. The first view_item_list waits until the
  guide is 5% visible (as snippets/homepage-tracker.liquid does) and is for the
  state shown then; after that, every place / mode / door height change fires
  at once. Events use the dataLayer format of snippets/homepage-tracker.liquid
  ({ ecommerce: null } first; items with item_id (product id), item_name, price,
  item_variant, 1-based index, item_list_name, item_list_id). No item_brand:
  the guide sends no vendor names.
*/
(function () {
  var root = document.querySelector('[data-cg-root]');
  if (!root) return;
  var url = root.getAttribute('data-cg-url');
  var MAX_CARDS = 12;
  var MIN_CARDS = 3;
  var EAGER = 5;

  var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-cg-tab]'));
  var places = Array.prototype.slice.call(root.querySelectorAll('[data-cg-place]'));
  var views = Array.prototype.slice.call(root.querySelectorAll('[data-cg-view]'));
  var switchEl = root.querySelector('[data-cg-switch]');
  var modeInputs = Array.prototype.slice.call(root.querySelectorAll('[data-cg-mode]'));
  var heightsRow = root.querySelector('[data-cg-heights]');
  var heightGroups = Array.prototype.slice.call(root.querySelectorAll('[data-cg-height-group]'));
  var heightInputs = Array.prototype.slice.call(root.querySelectorAll('[data-cg-height]'));
  var state = { place: tabs.length ? tabs[0].getAttribute('data-place') : null, mode: 'pair', heights: {} };
  heightInputs.forEach(function (input) {
    if (input.checked) state.heights[input.getAttribute('data-place')] = input.value;
  });

  // Earlier versions cached the whole feed (card HTML included, about 1.5 MB)
  // in sessionStorage under cg-data:* keys. Remove any left in this session.
  function dropOldCache() {
    try {
      for (var i = window.sessionStorage.length - 1; i >= 0; i--) {
        var key = window.sessionStorage.key(i);
        if (key && key.indexOf('cg-data:') === 0) window.sessionStorage.removeItem(key);
      }
    } catch (e) {
      /* storage blocked: nothing to clean */
    }
  }

  function getJSON(pageUrl) {
    return fetch(pageUrl, { credentials: 'same-origin' }).then(function (res) {
      if (!res.ok) throw new Error('guide data ' + res.status);
      return res.json();
    });
  }

  // Page 1 and page 2 are requested together. Page 2 is ignored when page 1
  // reports a single page; if page 2 fails, carousels render from page 1 alone.
  function loadProducts() {
    var second = getJSON(url + '&page=2').catch(function () { return null; });
    return Promise.all([getJSON(url), second]).then(function (res) {
      var first = res[0];
      var pages = Number(first.pages) || 1;
      var products = first.products.slice();
      if (pages > 1 && res[1]) products = products.concat(res[1].products);
      var rest = [];
      for (var p = 3; p <= pages; p++) {
        rest.push(getJSON(url + '&page=' + p).catch(function () { return null; }));
      }
      return Promise.all(rest).then(function (more) {
        more.forEach(function (d) {
          if (d) products = products.concat(d.products);
        });
        return products;
      });
    });
  }

  // Up to 12 products for one view: best-seller order, available, in range,
  // one product per design family.
  function pick(products, min, max) {
    var chosen = [];
    var seen = {};
    for (var i = 0; i < products.length && chosen.length < MAX_CARDS; i++) {
      var p = products[i];
      if (!p.available || typeof p.height !== 'number' || !p.card) continue;
      if (p.height < min || p.height > max) continue;
      var family = p.family || p.handle;
      if (seen[family]) continue;
      seen[family] = true;
      chosen.push(p);
    }
    return chosen;
  }

  // Fallback when fewer than MIN_CARDS fit: the products closest to the range
  // (nearest first, one per family), then shown largest first.
  function closest(products, min, max) {
    var pool = products.filter(function (p) { return p.available && typeof p.height === 'number' && p.card; });
    var dist = function (p) { return p.height < min ? min - p.height : (p.height > max ? p.height - max : 0); };
    pool.sort(function (a, b) { return dist(a) - dist(b) || b.height - a.height; });
    var chosen = [];
    var seen = {};
    for (var i = 0; i < pool.length && chosen.length < MAX_CARDS; i++) {
      var family = pool[i].family || pool[i].handle;
      if (seen[family]) continue;
      seen[family] = true;
      chosen.push(pool[i]);
    }
    return chosen.sort(function (a, b) { return b.height - a.height; });
  }

  // The og-card wrapper only sizes the slide; the card inside is the grid's.
  function cardHTML(p) {
    return '<div class="og-card">' + p.card + '</div>';
  }

  // Cards arrive after page load, so run the theme's lazy-image loader (as
  // product-recommendations does) and ask the wishlist app to add its buttons.
  // Each step is guarded: these are other people's scripts, and an error in
  // them must never reach render(). Swym's initializeActionButtons throws if
  // called before Swym has finished starting (its _swat object exists early),
  // so it is called directly only once the body has the swym-ready class, and
  // otherwise queued on SwymCallbacks, which Swym runs when it is ready.
  function initCards() {
    try {
      if (typeof window.initLazyImages === 'function') window.initLazyImages();
    } catch (e) { /* theme lazy loader failed: eagerLoad still set the first images */ }
    var swymInit = function (swat) {
      try {
        if (swat && typeof swat.initializeActionButtons === 'function') swat.initializeActionButtons('.og-guide');
      } catch (e) { /* wishlist app not ready or changed: cards stay as they are */ }
    };
    try {
      if (window._swat && document.body.classList.contains('swym-ready')) swymInit(window._swat);
      else (window.SwymCallbacks = window.SwymCallbacks || []).push(swymInit);
    } catch (e) { /* ignore */ }
  }

  // ---- Carousel arrows ------------------------------------------------------

  function updateArrows(carousel) {
    var track = carousel.querySelector('[data-cg-cards]');
    var prev = carousel.querySelector('[data-cg-prev]');
    var next = carousel.querySelector('[data-cg-next]');
    var max = track.scrollWidth - track.clientWidth;
    prev.hidden = track.scrollLeft <= 2;
    next.hidden = track.scrollLeft >= max - 2;
  }

  function step(carousel, dir) {
    var track = carousel.querySelector('[data-cg-cards]');
    var card = track.querySelector('.og-card');
    var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    var by = card ? (card.getBoundingClientRect().width + gap) * 3 : track.clientWidth * 0.8;
    track.scrollBy({ left: dir * by, behavior: 'smooth' });
  }

  views.forEach(function (view) {
    var carousel = view.querySelector('[data-cg-carousel]');
    var track = carousel.querySelector('[data-cg-cards]');
    carousel.querySelector('[data-cg-prev]').addEventListener('click', function () { step(carousel, -1); });
    carousel.querySelector('[data-cg-next]').addEventListener('click', function () { step(carousel, 1); });
    track.addEventListener('scroll', function () { updateArrows(carousel); }, { passive: true });
  });
  window.addEventListener('resize', function () {
    views.forEach(function (view) { if (view.hasAttribute('data-cg-filled')) updateArrows(view.querySelector('[data-cg-carousel]')); });
  });

  // ---- Place / mode selection -----------------------------------------------

  function modesFor(place) {
    var tab = tabs.filter(function (t) { return t.getAttribute('data-place') === place; })[0];
    return tab ? tab.getAttribute('data-modes').trim().split(/\s+/) : [];
  }

  // Grid card images keep their real sources in data-src / data-srcset until the
  // theme's lazy loader copies them; copy them here too, since that loader only
  // handles images still marked loading="lazy".
  function eagerLoad(view) {
    var imgs = view.querySelectorAll('[data-cg-cards] img');
    for (var i = 0; i < imgs.length && i < EAGER; i++) {
      var img = imgs[i];
      if (img.dataset.srcset && !img.srcset) img.srcset = img.dataset.srcset;
      if (img.dataset.src && (!img.getAttribute('src') || img.getAttribute('src').indexOf('data:') === 0)) img.src = img.dataset.src;
      img.loading = 'eager';
    }
  }

  function show() {
    var modes = modesFor(state.place);
    if (modes.indexOf(state.mode) === -1) state.mode = modes[0];
    var single = modes.length < 2;

    tabs.forEach(function (t) {
      var on = t.getAttribute('data-place') === state.place;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
    places.forEach(function (p) {
      var on = p.getAttribute('data-cg-place') === state.place;
      p.classList.toggle('is-active', on);
      if (on) p.removeAttribute('aria-hidden');
      else p.setAttribute('aria-hidden', 'true');
    });
    var height = state.heights[state.place] || '';
    views.forEach(function (v) {
      var on = v.getAttribute('data-place') === state.place && v.getAttribute('data-mode') === state.mode && v.getAttribute('data-height') === height;
      v.classList.toggle('is-active', on);
      if (on) {
        v.removeAttribute('aria-hidden');
        eagerLoad(v);
        if (v.hasAttribute('data-cg-filled')) updateArrows(v.querySelector('[data-cg-carousel]'));
      } else {
        v.setAttribute('aria-hidden', 'true');
      }
    });

    switchEl.classList.toggle('is-off', single);
    modeInputs.forEach(function (input) {
      input.disabled = single;
      input.checked = input.value === state.mode;
    });
    if (single) switchEl.setAttribute('aria-hidden', 'true');
    else switchEl.removeAttribute('aria-hidden');

    // Door height: the active place's group, or the row hidden (space kept).
    var hasGroup = false;
    heightGroups.forEach(function (g) {
      var on = g.getAttribute('data-place') === state.place;
      hasGroup = hasGroup || on;
      g.classList.toggle('is-active', on);
      if (on) g.removeAttribute('aria-hidden');
      else g.setAttribute('aria-hidden', 'true');
    });
    heightInputs.forEach(function (input) {
      input.disabled = input.getAttribute('data-place') !== state.place;
    });
    if (heightsRow) {
      heightsRow.classList.toggle('is-off', !hasGroup);
      if (hasGroup) heightsRow.removeAttribute('aria-hidden');
      else heightsRow.setAttribute('aria-hidden', 'true');
    }

    trackShownList();
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      state.place = tab.getAttribute('data-place');
      show();
    });
    tab.addEventListener('keydown', function (e) {
      var i = tabs.indexOf(tab);
      var next = null;
      if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
      else if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
      else if (e.key === 'Home') next = tabs[0];
      else if (e.key === 'End') next = tabs[tabs.length - 1];
      if (next) {
        e.preventDefault();
        state.place = next.getAttribute('data-place');
        show();
        next.focus();
      }
    });
  });

  modeInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      if (input.checked) {
        state.mode = input.value;
        show();
      }
    });
  });

  heightInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      if (input.checked) {
        state.heights[input.getAttribute('data-place')] = input.value;
        show();
      }
    });
  });

  // ---- GA4 list tracking ----------------------------------------------------

  function slug(s) {
    return String(s == null ? '' : s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function labelText(input) {
    var l = input ? root.querySelector('label[for="' + input.id + '"]') : null;
    return l ? l.textContent.trim() : '';
  }

  // List id and name for a view: "size-guide-front-pair-80" /
  // "Size Guide: Front door, Pair, Standard 80-inch" (button labels); porch has
  // no door height ("none"); a view showing the largest-lights fallback uses
  // one shared list.
  function listInfo(view) {
    if (view.__cgFallback) return { id: 'size-guide-fallback', name: 'Size Guide: Our largest outdoor wall lights' };
    var place = view.getAttribute('data-place'), mode = view.getAttribute('data-mode'), height = view.getAttribute('data-height');
    var tab = tabs.filter(function (t) { return t.getAttribute('data-place') === place; })[0];
    var modeInput = modeInputs.filter(function (i) { return i.value === mode; })[0];
    var heightInput = heightInputs.filter(function (i) { return i.getAttribute('data-place') === place && i.value === height; })[0];
    var parts = [tab ? tab.textContent.trim() : place, labelText(modeInput) || mode];
    if (height) parts.push(labelText(heightInput) || height);
    return { id: 'size-guide-' + slug(place) + '-' + slug(mode) + '-' + (height ? slug(height) : 'none'), name: 'Size Guide: ' + parts.join(', ') };
  }

  // Items as the homepage tracker sends them. item_id is the product id from
  // the feed (p.id), or the handle if the feed has no id; name and price are
  // read from the rendered card.
  function collectItems(track, chosen) {
    return Array.prototype.map.call(track.children, function (card, i) {
      var p = chosen[i] || {};
      var title = card.querySelector('.card__title .card-link, .card__title');
      var priceEl = card.querySelector('.price__current');
      var price = priceEl ? parseFloat(priceEl.textContent.replace(/[^0-9.]/g, '')) : NaN;
      var item = { item_id: p.id != null ? String(p.id) : String(p.handle || ''), item_name: title ? title.textContent.trim() : '', item_variant: p.handle || '', index: i + 1 };
      if (!isNaN(price)) item.price = price;
      return item;
    });
  }

  function withList(item, list) {
    var out = {};
    for (var k in item) out[k] = item[k];
    out.item_list_name = list.name;
    out.item_list_id = list.id;
    return out;
  }

  function pushEcommerce(event, list, items) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({ event: event, ecommerce: { item_list_name: list.name, item_list_id: list.id, items: items.map(function (it) { return withList(it, list); }) } });
    } catch (e) { /* tracking must never affect the guide */ }
  }

  var lastListView = null;
  var guideSeen = false;

  // One view_item_list each time a filled carousel becomes the one shown, once
  // the guide has been seen.
  function trackShownList() {
    if (!guideSeen) return;
    try {
      var view = views.filter(function (v) { return v.classList.contains('is-active'); })[0];
      if (!view || !view.hasAttribute('data-cg-filled') || view === lastListView || !view.__cgItems) return;
      lastListView = view;
      pushEcommerce('view_item_list', listInfo(view), view.__cgItems);
    } catch (e) { /* ignore */ }
  }

  // The guide counts as seen once 5% of it is in view (same threshold and
  // margin as the homepage tracker). Without IntersectionObserver it counts as
  // seen at once.
  if ('IntersectionObserver' in window) {
    var seenObserver = new IntersectionObserver(function (entries) {
      if (!entries.some(function (e) { return e.isIntersecting; })) return;
      seenObserver.disconnect();
      guideSeen = true;
      trackShownList();
    }, { threshold: 0.05, rootMargin: '50px 0px' });
    seenObserver.observe(root);
  } else {
    guideSeen = true;
  }

  // select_item on a click on a product link inside a card; synchronous, so
  // navigation is never delayed.
  views.forEach(function (view) {
    var track = view.querySelector('[data-cg-cards]');
    track.addEventListener('click', function (e) {
      try {
        var link = e.target.closest('a[href]');
        if (!link || !track.contains(link) || !/\/products\//.test(link.getAttribute('href'))) return;
        var card = link.closest('[data-cg-cards] > .og-card');
        var i = Array.prototype.indexOf.call(track.children, card);
        if (i < 0 || !view.__cgItems || !view.__cgItems[i]) return;
        pushEcommerce('select_item', listInfo(view), [view.__cgItems[i]]);
      } catch (err) { /* ignore */ }
    });
  });

  // ---- Render ---------------------------------------------------------------

  function render(products) {
    views.forEach(function (view) {
      var min = parseFloat(view.getAttribute('data-cg-min'));
      var max = parseFloat(view.getAttribute('data-cg-max'));
      var carousel = view.querySelector('[data-cg-carousel]');
      var track = carousel.querySelector('[data-cg-cards]');
      var chosen = pick(products, min, max);
      var fallback = chosen.length < MIN_CARDS;
      if (fallback) chosen = closest(products, min, max);
      carousel.querySelector('[data-cg-fallback]').hidden = !fallback;
      if (chosen.length < MIN_CARDS) {
        track.innerHTML = '';
        carousel.hidden = true;
        return;
      }
      track.innerHTML = chosen.map(cardHTML).join('');
      view.__cgFallback = fallback;
      try { view.__cgItems = collectItems(track, chosen); } catch (e) { view.__cgItems = null; }
      view.setAttribute('data-cg-filled', '');
      if (view.classList.contains('is-active')) eagerLoad(view);
      updateArrows(carousel);
    });
    show();
    root.setAttribute('data-cg-ready', '');
    try { performance.mark('cg-cards-rendered'); } catch (e) {}
    initCards();
  }

  var started = false;
  var observer = null;

  function start() {
    if (started) return;
    started = true;
    if (observer) observer.disconnect();
    dropOldCache();
    // Two-argument then: only a failed fetch hides the carousels. An error
    // inside render() is not routed here, so it can never remove drawn cards.
    loadProducts().then(render, function () {
      /* feed unavailable: drop the placeholders, views keep their size and guidance */
      views.forEach(function (view) { view.querySelector('[data-cg-carousel]').hidden = true; });
    });
  }

  show();

  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) start();
    }, { rootMargin: '600px 0px' });
    observer.observe(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
